import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
import { map, Observable, switchMap, take } from "rxjs";

import { WishlistItemSdkDto, WishlistSdkDto } from "../types";
import { mapWishlistItemToSdkDto } from "../utils/mapWishlistItemToSdkDto";
import { mapWishlistToSdkDto } from "../utils/mapWishlistToSdkDto";

export class WishlistsStackServiceWrapper {
    constructor(
        private readonly wishlistsService: WishlistsService,
        private readonly wishlistsQuery: WishlistsQuery
    ) {}

    getWishlists(): Observable<WishlistSdkDto[]> {
        return this.wishlistsService.getWishlists().pipe(
            switchMap(() => this.wishlistsQuery.selectAll()),
            take(1),
            map((wishlists) => wishlists.map(mapWishlistToSdkDto))
        );
    }

    addItem(params: {
        productId: number;
        variantId: number;
        wishlistId: number | null;
    }): Observable<WishlistItemSdkDto> {
        return this.wishlistsService
            .addItem(params)
            .pipe(map(mapWishlistItemToSdkDto));
    }

    deleteItem(params: {
        wishlistId: number | null;
        productId: number;
        variantId: number | null;
    }): Observable<WishlistItemSdkDto> {
        return this.wishlistsService
            .deleteItem(params)
            .pipe(map(mapWishlistItemToSdkDto));
    }
}
